import { Injectable } from '@angular/core';
import * as forge from 'node-forge';
import { ConfirmationService, Message, MessageService } from 'primeng/api';
import { LoginService } from '../services/login-participante.service';
import { saveAs } from 'file-saver';
import { FormControl, FormGroup, Validator, Validators} from '@angular/forms';
import { Workbook } from 'exceljs';



export class Utils {
    public confirmationService: ConfirmationService;
    public loginServices: LoginService;
    public desabilitaBotao: boolean;
    public messageService: MessageService;

  
    public logout(){
      this.confirmationService.confirm({
        message: 'Tem certeza que deseja sair?',
        accept:()=>{
          this.loginServices.logout();
          location.reload();
        },
        reject:()=>{
          this.desabilitaBotao = true;
          this.messageService.add({ key: 'toast', severity: 'error', summary: 'Informação', detail: 'Operação cancelada!' });
        },
      });
    }

    baixarModeloCsv(csvHeader, nomeTabela){
      var blob = new Blob([csvHeader], {type: 'text/csv'})
      saveAs(blob, `${nomeTabela}.csv`)
    }

    public formatacaoDeData(data: string){
      let arr = data.split("/");
      let dia = arr[0];
      let mes = arr[1];
      let ano = arr[2];
      let dataFormatada = `${ano}-${mes}-${dia}`;
      return dataFormatada;
    }

    public noWhitespaceValidator(control: FormControl) {
      var isWhitespace = (control.value || '').trim().length === 0;
      return isWhitespace ? { 'whitespace': true } : null;
    }

    public noWhitespaceValidatorString(text: String) {
      var isWhitespace = (text || '').trim().length === 0;
      return isWhitespace ? { 'whitespace': true } : null;
    }

    public noWhitespaceValidatorString2(text: String) {
      text.replace("&#160;",' ')
      var isWhitespace =  (text || '').trim().length === 0;
      return isWhitespace ?  true  : false;
    }

    public getHeaderArray(csvRecordsArr: any) {
      let headers = csvRecordsArr[0].split(';');
      let headerArray = [];
      for (let j = 0; j < headers.length; j++) {
        headerArray.push(headers[j]);
      }
      return headerArray;}

    somaTotalPorPlanos(dadosResultado:any,param:any):number{
      var sum = dadosResultado.filter(p=> p.plano == param).reduce((sum, element) => { return sum + element.numVotos; }, 0);
      return sum;
    }

    exportParaExcel(dadosResultado:any,titulo:String,listaPlanosFiltrada:any){
      let planilha = new Workbook();
      planilha.creator ='Carlos Lima - carlos.lima@sinqia.com.br';
      planilha.lastModifiedBy ='Carlos Lima';

      let paginas : any[] = [];
      listaPlanosFiltrada.forEach(lpf => {   //Cria páginas na planilha de acordo com a quantidade de planos na eleição
        if (lpf != ''){
        paginas.push(planilha.addWorksheet(lpf,{headerFooter:{oddFooter: "Total de Votos: " + this.somaTotalPorPlanos(dadosResultado,lpf)}}) // Define cabeçalhos e o roda pé como total dos votos(roda pé ao imprimir página da planilha).
        .columns =[
          { header: "Nº max de Votos por Eleitor", key: "num_vagas", width: 15,style: {alignment: {vertical: 'middle', horizontal: 'center' }}},
          { header: "Quantidade de votos recebidos", key: "q_votos", width: 30,style: {alignment: {vertical: 'middle', horizontal: 'center' }}},
          { header: "Candidato/Chapa", key: "candidato", width: 30,style: {alignment: {vertical: 'middle', horizontal: 'center' }}},
          { header: "Cargo", key: "cargo", width: 25,style: {alignment: {vertical: 'middle', horizontal: 'center' }}}
        ]);

        for (let x1 of dadosResultado.filter(p =>p.plano==lpf))
        {
          delete x1.id;   //remove elemento do objeto
          delete x1.eleicaoId;
          delete x1.eleito;
          delete x1.createdAt;
          delete x1.tipoVoto;
          delete x1.updateAt;
          let x2=Object.keys(x1) //Pega todos o elementos do Objeto
          let temp=[]
          for(let y of x2)
          {
            temp.push(x1[y])  //push da linha para o array
          }
          planilha.getWorksheet(lpf).addRow(temp).font = {name: 'Rubik',family: 2,size: 11}; //inclui as linhas na planilha
          this.aplicaEstiloPlanilha(planilha,lpf);
          planilha.getWorksheet(lpf).spliceColumns(5,5); //retira coluna plano sem bugar a pagina de resultados corrigir bug da coluna do plano.
        }
        }
        });

      planilha.xlsx.writeBuffer().then((data) => { //escreve a planilha e define o nome do arquivo.
        let blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        saveAs(blob, "Resultados - "+titulo+"-" +new Date().getFullYear()+'.xlsx');
      });
    }
    aplicaEstiloPlanilha(planilha: Workbook,lpf:any){
      planilha.getWorksheet(lpf).getCell('A1').font = {name: 'Rubik',color: { argb: 'FFFFFF' },family: 2,size: 11,},
      planilha.getWorksheet(lpf).getCell('A1').alignment= {vertical: 'middle', horizontal: 'center' },
      planilha.getWorksheet(lpf).getCell('A1').fill= {type: 'pattern', pattern: 'solid', fgColor: {argb: 'FFA4616'}}
      planilha.getWorksheet(lpf).getCell('B1').font = {name: 'Rubik',color: { argb: 'FFFFFF' },family: 2,size: 11,},
      planilha.getWorksheet(lpf).getCell('B1').alignment= {vertical: 'middle', horizontal: 'center' },
      planilha.getWorksheet(lpf).getCell('B1').fill= {type: 'pattern', pattern: 'solid', fgColor: {argb: 'FFA4616'}}
      planilha.getWorksheet(lpf).getCell('C1').font = {name: 'Rubik',color: { argb: 'FFFFFF' },family: 2,size: 11,},
      planilha.getWorksheet(lpf).getCell('C1').alignment= {vertical: 'middle', horizontal: 'center' },
      planilha.getWorksheet(lpf).getCell('C1').fill= {type: 'pattern', pattern: 'solid',fgColor: {argb: 'FFA4616'}}
      planilha.getWorksheet(lpf).getCell('D1').font = {name: 'Rubik',color: { argb: 'FFFFFF' },family: 2,size: 11,},
      planilha.getWorksheet(lpf).getCell('D1').alignment= {vertical: 'middle', horizontal: 'center' },
      planilha.getWorksheet(lpf).getCell('D1').fill= {type: 'pattern', pattern: 'solid', fgColor: {argb: 'FFA4616'}}
    }


    exportComprovantesParaExcel(resultados:any,titulo:String,listaPlanosFiltrada:any){
      let planilha = new Workbook();
      planilha.creator ='Carlos Lima - carlos.lima@sinqia.com.br';
      planilha.lastModifiedBy ='Carlos Lima';

      let paginas : any[] = [];
      listaPlanosFiltrada = listaPlanosFiltrada.filter( plano => plano.toUpperCase() != "GERAL" && plano != "");
      paginas.push(planilha.addWorksheet("Geral")
      .columns =[
        { header: "Login", key: "login", width: 15,style: {alignment: {vertical: 'middle', horizontal: 'center' }}},
        { header: "HashComprovante", key: "hash", width: 35,style: {alignment: {vertical: 'middle', horizontal: 'center' }}},
        { header: "Cargo", key: "cargo", width: 25,style: {alignment: {vertical: 'middle', horizontal: 'center' }}},
        { header: "Agrupador", key: "agrupador", width: 20,style: {alignment: {vertical: 'middle', horizontal: 'center' }}},
        { header: "UF", key: "uf", width: 18,style: {alignment: {vertical: 'middle', horizontal: 'center' }}}
       
      ]);
      if (listaPlanosFiltrada.length > 0) {
        paginas.push(planilha.addWorksheet("Sem Plano")
        .columns =[
          { header: "Login", key: "login", width: 15,style: {alignment: {vertical: 'middle', horizontal: 'center' }}},
          { header: "HashComprovante", key: "hash", width: 35,style: {alignment: {vertical: 'middle', horizontal: 'center' }}},
          { header: "Cargo", key: "cargo", width: 25,style: {alignment: {vertical: 'middle', horizontal: 'center' }}},
          { header: "Agrupador", key: "agrupador", width: 20,style: {alignment: {vertical: 'middle', horizontal: 'center' }}},
          { header: "UF", key: "uf", width: 18,style: {alignment: {vertical: 'middle', horizontal: 'center' }}}
         

        ]);
      }
      for (let registro of resultados.filter(p => p.planoEleitor=="Geral" || p.planoEleitor=="")) {
        let registroCopia = JSON.parse(JSON.stringify(registro));
        delete registroCopia.cargoId;
        delete registroCopia.planoEleitor;
        let keys = Object.keys(registroCopia) //Pega todos o elementos do Objeto
        let temp=[]
        for(let i of keys) {
          temp.push(registroCopia[i])  //push da linha para o array
        }
        planilha.getWorksheet("Geral").addRow(temp).font = {name: 'Rubik',family: 2,size: 11}; //inclui as linhas na planilha
        if (listaPlanosFiltrada.length > 0) {
          planilha.getWorksheet("Sem Plano").addRow(temp).font = {name: 'Rubik',family: 2,size: 11};
          this.aplicaEstiloPlanilhaVotantes(planilha,"Sem Plano");
        }
        this.aplicaEstiloPlanilhaVotantes(planilha,"Geral");
      }

      listaPlanosFiltrada.forEach(lpf => { //Cria páginas na planilha de acordo com a quantidade de planos na eleição
          paginas.push(planilha.addWorksheet(lpf) // Define cabeçalhos e o roda pé como total dos votos(roda pé ao imprimir página da planilha).
          .columns =[
            { header: "Login", key: "login", width: 15,style: {alignment: {vertical: 'middle', horizontal: 'center' }}},
            { header: "HashComprovante", key: "hash", width: 35,style: {alignment: {vertical: 'middle', horizontal: 'center' }}},
            { header: "Cargo", key: "cargo", width: 25,style: {alignment: {vertical: 'middle', horizontal: 'center' }}},
            { header: "Agrupador", key: "agrupador", width: 20,style: {alignment: {vertical: 'middle', horizontal: 'center' }}},
            { header: "UF", key: "uf", width: 18,style: {alignment: {vertical: 'middle', horizontal: 'center' }}}
          ]);

          for (let registro of resultados.filter(p =>p.planoEleitor==lpf)) {
            let registroCopia = JSON.parse(JSON.stringify(registro));
            delete registroCopia.cargoId;
            delete registroCopia.planoEleitor;
            let keys = Object.keys(registroCopia) //Pega todos o elementos do Objeto
            let temp=[]
            for(let i of keys) {
              temp.push(registroCopia[i]) //push da linha para o array
            }
            planilha.getWorksheet(lpf).addRow(temp).font = {name: 'Rubik',family: 2,size: 11}; //inclui as linhas na planilha
            planilha.getWorksheet("Geral").addRow(temp).font = {name: 'Rubik',family: 2,size: 11};
            this.aplicaEstiloPlanilhaVotantes(planilha,lpf);
          }
      });

      this.aplicaEstiloPlanilhaVotantes(planilha,"Geral");
      planilha.xlsx.writeBuffer().then((data) => { //escreve a planilha e define o nome do arquivo.
        let blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        saveAs(blob, "Comprovantes - "+titulo+"-" +new Date().getFullYear()+'.xlsx');
      });
    }

    exportRelatoriosParaExcel(logins:any){
      let planilha = new Workbook();

      let paginas : any[] = [];
      paginas.push(planilha.addWorksheet("Geral")
      .columns =[
        { header: "Eleitor", key: "nome", width: 15,style: {alignment: {vertical: 'middle', horizontal: 'center' }}},
        { header: "Data", key: "data", width: 35,style: {alignment: {vertical: 'middle', horizontal: 'center' }}},
        { header: "Hora", key: "hora", width: 25,style: {alignment: {vertical: 'middle', horizontal: 'center' }}},
        { header: "Evento", key: "evento", width: 25,style: {alignment: {vertical: 'middle', horizontal: 'center' }}},
        { header: "IP", key: "ip", width: 25,style: {alignment: {vertical: 'middle', horizontal: 'center' }}}
      ]);
      
      for (let registro of logins) {
        let registroCopia = JSON.parse(JSON.stringify(registro));
        delete registroCopia.id;
        let keys = Object.keys(registroCopia);
        let temp = [];
        for (let i of keys) {
          temp.push(registroCopia[i]);
        }
        
        let dataCompleta = temp[0];
        let valoresData = dataCompleta.split("T");
        let data = valoresData[0];
        let horaCompleta = valoresData[1].split(".");
        let hora = horaCompleta[0];
        let nome = temp[1];
        let evento = temp[2];
        let ip = temp[3];
        let invertendoData = data.split("-");
        let dataAno = invertendoData[0];
        let dataMes = invertendoData[1];
        let dataDia = invertendoData[2];
        let dataFormatada = dataDia + "/" + dataMes + "/" + dataAno
        let linha = {
          nome: nome,
          data: dataFormatada,
          hora: hora,
          evento: evento,
          ip: ip
        };

        planilha.getWorksheet("Geral").addRow(linha).font = { name: 'Rubik', family: 2, size: 11 };
      }
      planilha.getWorksheet("Geral").getCell('A1').font = {name: 'Rubik',color: { argb: 'FFFFFF' },family: 2,size: 11,},
      planilha.getWorksheet("Geral").getCell('A1').alignment= {vertical: 'middle', horizontal: 'center' },
      planilha.getWorksheet("Geral").getCell('A1').fill= {type: 'pattern', pattern: 'solid', fgColor: {argb: 'FFA4616'}}
      planilha.getWorksheet("Geral").getCell('B1').font = {name: 'Rubik',color: { argb: 'FFFFFF' },family: 2,size: 11,},
      planilha.getWorksheet("Geral").getCell('B1').alignment= {vertical: 'middle', horizontal: 'center' },
      planilha.getWorksheet("Geral").getCell('B1').fill= {type: 'pattern', pattern: 'solid', fgColor: {argb: 'FFA4616'}}
      planilha.getWorksheet("Geral").getCell('C1').font = {name: 'Rubik',color: { argb: 'FFFFFF' },family: 2,size: 11,},
      planilha.getWorksheet("Geral").getCell('C1').alignment= {vertical: 'middle', horizontal: 'center' },
      planilha.getWorksheet("Geral").getCell('C1').fill= {type: 'pattern', pattern: 'solid',fgColor: {argb: 'FFA4616'}}
      planilha.getWorksheet("Geral").getCell('D1').font = {name: 'Rubik',color: { argb: 'FFFFFF' },family: 2,size: 11,},
      planilha.getWorksheet("Geral").getCell('D1').alignment= {vertical: 'middle', horizontal: 'center' },
      planilha.getWorksheet("Geral").getCell('D1').fill= {type: 'pattern', pattern: 'solid',fgColor: {argb: 'FFA4616'}}
      planilha.getWorksheet("Geral").getCell('E1').font = {name: 'Rubik',color: { argb: 'FFFFFF' },family: 2,size: 11,},
      planilha.getWorksheet("Geral").getCell('E1').alignment= {vertical: 'middle', horizontal: 'center' },
      planilha.getWorksheet("Geral").getCell('E1').fill= {type: 'pattern', pattern: 'solid',fgColor: {argb: 'FFA4616'}}

      planilha.xlsx.writeBuffer().then((data) => { //escreve a planilha e define o nome do arquivo.
        let blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        
        saveAs(blob, "Relatório de Logins"+'.xlsx');
      });
    }

    aplicaEstiloPlanilhaVotantes(planilha: Workbook,lpf:any){
      planilha.getWorksheet(lpf).getCell('A1').font = {name: 'Rubik',color: { argb: 'FFFFFF' },family: 2,size: 11,},
      planilha.getWorksheet(lpf).getCell('A1').alignment= {vertical: 'middle', horizontal: 'center' },
      planilha.getWorksheet(lpf).getCell('A1').fill= {type: 'pattern', pattern: 'solid', fgColor: {argb: 'FFA4616'}}
      planilha.getWorksheet(lpf).getCell('B1').font = {name: 'Rubik',color: { argb: 'FFFFFF' },family: 2,size: 11,},
      planilha.getWorksheet(lpf).getCell('B1').alignment= {vertical: 'middle', horizontal: 'center' },
      planilha.getWorksheet(lpf).getCell('B1').fill= {type: 'pattern', pattern: 'solid', fgColor: {argb: 'FFA4616'}}
      planilha.getWorksheet(lpf).getCell('C1').font = {name: 'Rubik',color: { argb: 'FFFFFF' },family: 2,size: 11,},
      planilha.getWorksheet(lpf).getCell('C1').alignment= {vertical: 'middle', horizontal: 'center' },
      planilha.getWorksheet(lpf).getCell('C1').fill= {type: 'pattern', pattern: 'solid',fgColor: {argb: 'FFA4616'}}
      planilha.getWorksheet(lpf).getCell('D1').font = {name: 'Rubik',color: { argb: 'FFFFFF' },family: 2,size: 11,},
      planilha.getWorksheet(lpf).getCell('D1').alignment= {vertical: 'middle', horizontal: 'center' },
      planilha.getWorksheet(lpf).getCell('D1').fill= {type: 'pattern', pattern: 'solid', fgColor: {argb: 'FFA4616'}}
      planilha.getWorksheet(lpf).getCell('E1').font = {name: 'Rubik',color: { argb: 'FFFFFF' },family: 2,size: 11,},
      planilha.getWorksheet(lpf).getCell('E1').alignment= {vertical: 'middle', horizontal: 'center' },
      planilha.getWorksheet(lpf).getCell('E1').fill= {type: 'pattern', pattern: 'solid', fgColor: {argb: 'FFA4616'}}
    }

    exportRelatorioVotosParaExcel(votosEleicao:any,titulo:string, rastreabilidade:boolean){
      let planilha = new Workbook();
      planilha.creator ='Sinqia';
      planilha.lastModifiedBy ='Sinqia';
      let nameWorksheet = "Votos";
      let paginas : any[] = [];

      if(rastreabilidade){
        paginas.push(planilha.addWorksheet(nameWorksheet,{headerFooter:{oddFooter: "Total de Votos: " + votosEleicao.length}}) // Define cabeçalhos e o roda pé como total dos votos(roda pé ao imprimir página da planilha).
      .columns =[
        { header: "Eleitor", key: "nome", width: 15,style: {alignment: {vertical: 'middle', horizontal: 'center' }}},
        { header: "Plano", key: "plano", width: 30,style: {alignment: {vertical: 'middle', horizontal: 'center' }}},
        { header: "Cargo", key: "cargo", width: 30,style: {alignment: {vertical: 'middle', horizontal: 'center' }}},
        { header: "Voto", key: "voto", width: 25,style: {alignment: {vertical: 'middle', horizontal: 'center' }}},
        { header: "Justificativa", key: "justificativa", width: 25,style: {alignment: {vertical: 'middle', horizontal: 'center' }}},
        { header: "Data", key: "data", width: 15,style: {alignment: {vertical: 'middle', horizontal: 'center' }}},
        { header: "Hora", key: "hora", width: 15,style: {alignment: {vertical: 'middle', horizontal: 'center' }}}
      ]);
      }else{
        paginas.push(planilha.addWorksheet(nameWorksheet,{headerFooter:{oddFooter: "Total de Votos: "}}) // Define cabeçalhos e o roda pé como total dos votos(roda pé ao imprimir página da planilha).
      .columns =[
        { header: "Plano", key: "plano", width: 30,style: {alignment: {vertical: 'middle', horizontal: 'center' }}},
        { header: "Cargo", key: "cargo", width: 30,style: {alignment: {vertical: 'middle', horizontal: 'center' }}},
        { header: "Voto", key: "voto", width: 25,style: {alignment: {vertical: 'middle', horizontal: 'center' }}},
        { header: "Justificativa", key: "justificativa", width: 25,style: {alignment: {vertical: 'middle', horizontal: 'center' }}},
        { header: "Data", key: "data", width: 15,style: {alignment: {vertical: 'middle', horizontal: 'center' }}},
        { header: "Hora", key: "hora", width: 15,style: {alignment: {vertical: 'middle', horizontal: 'center' }}}
      ]);
      }
      

      for (let registro of votosEleicao) {
        let registroCopia = JSON.parse(JSON.stringify(registro));
        //delete registroCopia.id;
        let keys = Object.keys(registroCopia);
        let temp = [];
        for (let i of keys) {
          temp.push(registroCopia[i]);
        }
        let dataCompleta = temp[3];
        let valoresData = dataCompleta.split("T");
        let data = valoresData[0];
        let horaCompleta = valoresData[1].split(".");
        let invertendoData = data.split("-");
        let dataAno = invertendoData[0];
        let dataMes = invertendoData[1];
        let dataDia = invertendoData[2];

        let plano = temp[5];
        let cargo = temp[8];
        let voto = temp[7];
        let justificativa = temp[6];
        let dataFormatada = dataDia + "/" + dataMes + "/" + dataAno;
        let hora = horaCompleta[0];
        let nome = temp[9];

        if(rastreabilidade){
          let linha = {
            nome: nome,
            plano: plano,
            cargo: cargo,
            voto: voto,
            justificativa: justificativa,
            data: dataFormatada,
            hora: hora
          };

          planilha.getWorksheet(nameWorksheet).addRow(linha).font = {
            name: 'Rubik',
            family: 2,
            size: 11
          };

        }else{
          let linha = {
            plano: plano,
            cargo: cargo,
            voto: voto,
            justificativa: justificativa,
            data: dataFormatada,
            hora: hora
          };

          planilha.getWorksheet(nameWorksheet).addRow(linha).font = {
            name: 'Rubik',
            family: 2,
            size: 11
          };
        }
        
      }
      
      this.aplicaEstiloPlanilhaRelatorioVotos(planilha, nameWorksheet, rastreabilidade);

      planilha.xlsx.writeBuffer().then((data) => { //escreve a planilha e define o nome do arquivo.
        let blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        saveAs(blob, "Votos - "+titulo+"-" +new Date().getFullYear()+'.xlsx');
      });
    }

  aplicaEstiloPlanilhaRelatorioVotos(planilha: Workbook, lpf: any, rastreabilidade: any) {

    planilha.getWorksheet(lpf).getCell('A1').font = { name: 'Rubik', color: { argb: 'FFFFFF' }, family: 2, size: 11, },
      planilha.getWorksheet(lpf).getCell('A1').alignment = { vertical: 'middle', horizontal: 'center' },
      planilha.getWorksheet(lpf).getCell('A1').fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFA4616' } }
    planilha.getWorksheet(lpf).getCell('B1').font = { name: 'Rubik', color: { argb: 'FFFFFF' }, family: 2, size: 11, },
      planilha.getWorksheet(lpf).getCell('B1').alignment = { vertical: 'middle', horizontal: 'center' },
      planilha.getWorksheet(lpf).getCell('B1').fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFA4616' } }
    planilha.getWorksheet(lpf).getCell('C1').font = { name: 'Rubik', color: { argb: 'FFFFFF' }, family: 2, size: 11, },
      planilha.getWorksheet(lpf).getCell('C1').alignment = { vertical: 'middle', horizontal: 'center' },
      planilha.getWorksheet(lpf).getCell('C1').fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFA4616' } }
    planilha.getWorksheet(lpf).getCell('D1').font = { name: 'Rubik', color: { argb: 'FFFFFF' }, family: 2, size: 11, },
      planilha.getWorksheet(lpf).getCell('D1').alignment = { vertical: 'middle', horizontal: 'center' },
      planilha.getWorksheet(lpf).getCell('D1').fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFA4616' } }
    planilha.getWorksheet(lpf).getCell('E1').font = { name: 'Rubik', color: { argb: 'FFFFFF' }, family: 2, size: 11, },
      planilha.getWorksheet(lpf).getCell('E1').alignment = { vertical: 'middle', horizontal: 'center' },
      planilha.getWorksheet(lpf).getCell('E1').fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFA4616' } }
    planilha.getWorksheet(lpf).getCell('F1').font = { name: 'Rubik', color: { argb: 'FFFFFF' }, family: 2, size: 11, },
      planilha.getWorksheet(lpf).getCell('F1').alignment = { vertical: 'middle', horizontal: 'center' },
      planilha.getWorksheet(lpf).getCell('F1').fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFA4616' } }

    if (rastreabilidade) {
      planilha.getWorksheet(lpf).getCell('G1').font = { name: 'Rubik', color: { argb: 'FFFFFF' }, family: 2, size: 11, },
        planilha.getWorksheet(lpf).getCell('G1').alignment = { vertical: 'middle', horizontal: 'center' },
        planilha.getWorksheet(lpf).getCell('G1').fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFA4616' } }
    }
  }

  enc(text: string, p: any): string {
    const publicKey = forge.pki.publicKeyFromPem(p);
    const plaintextBytes = forge.util.encodeUtf8(text);
    const encrypted = publicKey.encrypt(plaintextBytes);
    const encryptedBase64 = forge.util.encode64(encrypted);
    return encryptedBase64;
  }


  exportRelatorioEmailParaExcel(emailsEleicao: any) {
    let planilha = new Workbook();
    planilha.creator = 'Sinqia';
    planilha.lastModifiedBy = 'Sinqia';
    let nameWorksheet = "Emails";
    let paginas: any[] = [];

    paginas.push(planilha.addWorksheet(nameWorksheet, { headerFooter: { oddFooter: "Total de Votos: " + emailsEleicao.length } }) // Define cabeçalhos e o roda pé como total dos votos(roda pé ao imprimir página da planilha).
      .columns = [
        { header: "Usuário", key: "loginUsuario", width: 15, style: { alignment: { vertical: 'middle', horizontal: 'center' } } },
        { header: "Tipo usuário", key: "tipoUsuario", width: 15, style: { alignment: { vertical: 'middle', horizontal: 'center' } } },
        { header: "E-mail", key: "destinatario", width: 30, style: { alignment: { vertical: 'middle', horizontal: 'center' } } },
        { header: "Data envio", key: "dataEnvio", width: 30, style: { alignment: { vertical: 'middle', horizontal: 'center' } } },
        { header: "Hora envio", key: "horaEnvio", width: 25, style: { alignment: { vertical: 'middle', horizontal: 'center' } } },
        { header: "Status", key: "status", width: 25, style: { alignment: { vertical: 'middle', horizontal: 'center' } } },
        { header: "Data evento", key: "dataEvento", width: 15, style: { alignment: { vertical: 'middle', horizontal: 'center' } } },
        { header: "Hora evento", key: "horaEvento", width: 15, style: { alignment: { vertical: 'middle', horizontal: 'center' } } }
      ]);

    for (let registro of emailsEleicao) {
      let registroCopia = JSON.parse(JSON.stringify(registro));
      //delete registroCopia.id;
      let keys = Object.keys(registroCopia);
      let temp = [];
      for (let i of keys) {
        temp.push(registroCopia[i]);
      }
      let keysEventos = Object.keys(registroCopia.eventos[0]);
      for (let i of keysEventos) {
        temp.push(registroCopia.eventos[0][i]);
      }
      let dataCompletaEmail = temp[2];
      let valoresDataEmail = dataCompletaEmail.split("T");
      let dataEmail = valoresDataEmail[0];
      let horaCompletaEmail = valoresDataEmail[1].split(".");
      let invertendoDataEmail = dataEmail.split("-");
      let dataAnoEmail = invertendoDataEmail[0];
      let dataMesEmail = invertendoDataEmail[1];
      let dataDiaEmail = invertendoDataEmail[2];

      let dataCompletaEvento = temp[10];
      let valoresDataEvento = dataCompletaEvento.split("T");
      let dataEvento = valoresDataEvento[0];
      let horaCompletaEvento = valoresDataEvento[1].split(".");
      let invertendoDataEvento = dataEvento.split("-");
      let dataAnoEvento = invertendoDataEvento[0];
      let dataMesEvento = invertendoDataEvento[1];
      let dataDiaEvento = invertendoDataEvento[2];

      let loginUsuario = temp[3];
      let tipoUsuario = temp[4];
      let destinatario = temp[5];
      let dataEnvio = dataDiaEmail + "/" + dataMesEmail + "/" + dataAnoEmail;
      let horaEnvio = horaCompletaEmail[0];
      let status = temp[13];
      let dataEventoFormatada = dataDiaEvento + "/" + dataMesEvento + "/" + dataAnoEvento;
      let horaEvento = horaCompletaEvento[0];

      let linha = {
        loginUsuario: loginUsuario,
        tipoUsuario: tipoUsuario,
        destinatario: destinatario,
        dataEnvio: dataEnvio,
        horaEnvio: horaEnvio,
        status: status,
        dataEvento: dataEventoFormatada,
        horaEvento: horaEvento
      };

      planilha.getWorksheet(nameWorksheet).addRow(linha).font = {
        name: 'Rubik',
        family: 2,
        size: 11
      };

    }

    this.aplicaEstiloPlanilhaRelatorioEmail(planilha, nameWorksheet);

    planilha.xlsx.writeBuffer().then((data) => { //escreve a planilha e define o nome do arquivo.
      let blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      saveAs(blob, "Emails - " + new Date().getFullYear() + '.xlsx');
    });
  }

  aplicaEstiloPlanilhaRelatorioEmail(planilha: Workbook, lpf: any) {

    planilha.getWorksheet(lpf).getCell('A1').font = { name: 'Rubik', color: { argb: 'FFFFFF' }, family: 2, size: 11, },
      planilha.getWorksheet(lpf).getCell('A1').alignment = { vertical: 'middle', horizontal: 'center' },
      planilha.getWorksheet(lpf).getCell('A1').fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFA4616' } }
    planilha.getWorksheet(lpf).getCell('B1').font = { name: 'Rubik', color: { argb: 'FFFFFF' }, family: 2, size: 11, },
      planilha.getWorksheet(lpf).getCell('B1').alignment = { vertical: 'middle', horizontal: 'center' },
      planilha.getWorksheet(lpf).getCell('B1').fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFA4616' } }
    planilha.getWorksheet(lpf).getCell('C1').font = { name: 'Rubik', color: { argb: 'FFFFFF' }, family: 2, size: 11, },
      planilha.getWorksheet(lpf).getCell('C1').alignment = { vertical: 'middle', horizontal: 'center' },
      planilha.getWorksheet(lpf).getCell('C1').fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFA4616' } }
    planilha.getWorksheet(lpf).getCell('D1').font = { name: 'Rubik', color: { argb: 'FFFFFF' }, family: 2, size: 11, },
      planilha.getWorksheet(lpf).getCell('D1').alignment = { vertical: 'middle', horizontal: 'center' },
      planilha.getWorksheet(lpf).getCell('D1').fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFA4616' } }
    planilha.getWorksheet(lpf).getCell('E1').font = { name: 'Rubik', color: { argb: 'FFFFFF' }, family: 2, size: 11, },
      planilha.getWorksheet(lpf).getCell('E1').alignment = { vertical: 'middle', horizontal: 'center' },
      planilha.getWorksheet(lpf).getCell('E1').fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFA4616' } }
    planilha.getWorksheet(lpf).getCell('F1').font = { name: 'Rubik', color: { argb: 'FFFFFF' }, family: 2, size: 11, },
      planilha.getWorksheet(lpf).getCell('F1').alignment = { vertical: 'middle', horizontal: 'center' },
      planilha.getWorksheet(lpf).getCell('F1').fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFA4616' } }
    planilha.getWorksheet(lpf).getCell('G1').font = { name: 'Rubik', color: { argb: 'FFFFFF' }, family: 2, size: 11, },
      planilha.getWorksheet(lpf).getCell('G1').alignment = { vertical: 'middle', horizontal: 'center' },
      planilha.getWorksheet(lpf).getCell('G1').fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFA4616' } }
    planilha.getWorksheet(lpf).getCell('H1').font = { name: 'Rubik', color: { argb: 'FFFFFF' }, family: 2, size: 11, },
      planilha.getWorksheet(lpf).getCell('H1').alignment = { vertical: 'middle', horizontal: 'center' },
      planilha.getWorksheet(lpf).getCell('H1').fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFA4616' } }
  }

  exportRelatorioDetalhadoEmailParaExcel(emailEleicao: any, eventosEmail: any) {
    let planilha = new Workbook();
    planilha.creator = 'Sinqia';
    planilha.lastModifiedBy = 'Sinqia';
    let nameWorksheet = "Emails";
    let paginas: any[] = [];

    paginas.push(planilha.addWorksheet(nameWorksheet, { headerFooter: { oddFooter: "Total de Votos: " + eventosEmail.length } }) // Define cabeçalhos e o roda pé como total dos votos(roda pé ao imprimir página da planilha).
      .columns = [
        { header: "Login", key: "loginUsuario", width: 15, style: { alignment: { vertical: 'middle', horizontal: 'center' } } },
        { header: "E-mail", key: "destinatario", width: 30, style: { alignment: { vertical: 'middle', horizontal: 'center' } } },
        { header: "Data envio", key: "dataEnvio", width: 30, style: { alignment: { vertical: 'middle', horizontal: 'center' } } },
        { header: "Hora envio", key: "horaEnvio", width: 25, style: { alignment: { vertical: 'middle', horizontal: 'center' } } },
        { header: "Status", key: "status", width: 25, style: { alignment: { vertical: 'middle', horizontal: 'center' } } },
        { header: "Mensagem", key: "mensagem", width: 25, style: { alignment: { vertical: 'middle', horizontal: 'center' } } },
        { header: "Data evento", key: "dataEvento", width: 15, style: { alignment: { vertical: 'middle', horizontal: 'center' } } },
        { header: "Hora evento", key: "horaEvento", width: 15, style: { alignment: { vertical: 'middle', horizontal: 'center' } } }
      ]);

    for (let registro of eventosEmail) {
      let registroCopia = JSON.parse(JSON.stringify(registro));
      let registroCopiaEmail = JSON.parse(JSON.stringify(emailEleicao));
      //delete registroCopia.id;
      let keys = Object.keys(registroCopiaEmail);
      let temp = [];
      for (let i of keys) {
        temp.push(registroCopiaEmail[i]);
      }
      let keysEventos = Object.keys(registroCopia);
      for (let i of keysEventos) {
        temp.push(registroCopia[i]);
      }
      let dataCompletaEmail = temp[2];
      let valoresDataEmail = dataCompletaEmail.split("T");
      let dataEmail = valoresDataEmail[0];
      let horaCompletaEmail = valoresDataEmail[1].split(".");
      let invertendoDataEmail = dataEmail.split("-");
      let dataAnoEmail = invertendoDataEmail[0];
      let dataMesEmail = invertendoDataEmail[1];
      let dataDiaEmail = invertendoDataEmail[2];

      let dataCompletaEvento = temp[10];
      let valoresDataEvento = dataCompletaEvento.split("T");
      let dataEvento = valoresDataEvento[0];
      let horaCompletaEvento = valoresDataEvento[1].split(".");
      let invertendoDataEvento = dataEvento.split("-");
      let dataAnoEvento = invertendoDataEvento[0];
      let dataMesEvento = invertendoDataEvento[1];
      let dataDiaEvento = invertendoDataEvento[2];

      let loginUsuario = temp[3];
      let destinatario = temp[5];
      let dataEnvio = dataDiaEmail + "/" + dataMesEmail + "/" + dataAnoEmail;
      let horaEnvio = horaCompletaEmail[0];
      let status = temp[13];
      let mensagem = temp[11];
      let dataEventoFormatada = dataDiaEvento + "/" + dataMesEvento + "/" + dataAnoEvento;
      let horaEvento = horaCompletaEvento[0];

      let linha = {
        loginUsuario: loginUsuario,
        destinatario: destinatario,
        dataEnvio: dataEnvio,
        horaEnvio: horaEnvio,
        status: status,
        mensagem: mensagem,
        dataEvento: dataEventoFormatada,
        horaEvento: horaEvento
      };

      planilha.getWorksheet(nameWorksheet).addRow(linha).font = {
        name: 'Rubik',
        family: 2,
        size: 11
      };

    }

    this.aplicaEstiloPlanilhaRelatorioDetalhadoEmail(planilha, nameWorksheet);

    planilha.xlsx.writeBuffer().then((data) => { //escreve a planilha e define o nome do arquivo.
      let blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      saveAs(blob, "Emails - " + new Date().getFullYear() + '.xlsx');
    });
  }

  aplicaEstiloPlanilhaRelatorioDetalhadoEmail(planilha: Workbook, lpf: any) {

    planilha.getWorksheet(lpf).getCell('A1').font = { name: 'Rubik', color: { argb: 'FFFFFF' }, family: 2, size: 11, },
      planilha.getWorksheet(lpf).getCell('A1').alignment = { vertical: 'middle', horizontal: 'center' },
      planilha.getWorksheet(lpf).getCell('A1').fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFA4616' } }
    planilha.getWorksheet(lpf).getCell('B1').font = { name: 'Rubik', color: { argb: 'FFFFFF' }, family: 2, size: 11, },
      planilha.getWorksheet(lpf).getCell('B1').alignment = { vertical: 'middle', horizontal: 'center' },
      planilha.getWorksheet(lpf).getCell('B1').fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFA4616' } }
    planilha.getWorksheet(lpf).getCell('C1').font = { name: 'Rubik', color: { argb: 'FFFFFF' }, family: 2, size: 11, },
      planilha.getWorksheet(lpf).getCell('C1').alignment = { vertical: 'middle', horizontal: 'center' },
      planilha.getWorksheet(lpf).getCell('C1').fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFA4616' } }
    planilha.getWorksheet(lpf).getCell('D1').font = { name: 'Rubik', color: { argb: 'FFFFFF' }, family: 2, size: 11, },
      planilha.getWorksheet(lpf).getCell('D1').alignment = { vertical: 'middle', horizontal: 'center' },
      planilha.getWorksheet(lpf).getCell('D1').fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFA4616' } }
    planilha.getWorksheet(lpf).getCell('E1').font = { name: 'Rubik', color: { argb: 'FFFFFF' }, family: 2, size: 11, },
      planilha.getWorksheet(lpf).getCell('E1').alignment = { vertical: 'middle', horizontal: 'center' },
      planilha.getWorksheet(lpf).getCell('E1').fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFA4616' } }
    planilha.getWorksheet(lpf).getCell('F1').font = { name: 'Rubik', color: { argb: 'FFFFFF' }, family: 2, size: 11, },
      planilha.getWorksheet(lpf).getCell('F1').alignment = { vertical: 'middle', horizontal: 'center' },
      planilha.getWorksheet(lpf).getCell('F1').fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFA4616' } }
    planilha.getWorksheet(lpf).getCell('G1').font = { name: 'Rubik', color: { argb: 'FFFFFF' }, family: 2, size: 11, },
      planilha.getWorksheet(lpf).getCell('G1').alignment = { vertical: 'middle', horizontal: 'center' },
      planilha.getWorksheet(lpf).getCell('G1').fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFA4616' } }
    planilha.getWorksheet(lpf).getCell('H1').font = { name: 'Rubik', color: { argb: 'FFFFFF' }, family: 2, size: 11, },
      planilha.getWorksheet(lpf).getCell('H1').alignment = { vertical: 'middle', horizontal: 'center' },
      planilha.getWorksheet(lpf).getCell('H1').fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFA4616' } }
  }

  exportRelatorioCandidaturaSintetico(candidaturas:any){
    let planilha = new Workbook();

    let paginas : any[] = [];
    paginas.push(planilha.addWorksheet("Geral")
    .columns =[
      { header: "Cargo", key: "cargo", width: 15,style: {alignment: {vertical: 'middle', horizontal: 'center' }}},
      { header: "Nome", key: "nome", width: 35,style: {alignment: {vertical: 'middle', horizontal: 'center' }}},
      { header: "CPF", key: "cpf", width: 25,style: {alignment: {vertical: 'middle', horizontal: 'center' }}},
      { header: "Currículo", key: "curriculo", width: 25,style: {alignment: {vertical: 'middle', horizontal: 'center' }}},
      { header: "E-mail", key: "email", width: 25,style: {alignment: {vertical: 'middle', horizontal: 'center' }}},
      { header: "Situação", key: "situacao", width: 25,style: {alignment: {vertical: 'middle', horizontal: 'center' }}},
    ]);
    
    for (let registro of candidaturas) {
      let registroCopia = JSON.parse(JSON.stringify(registro));
      delete registroCopia.id;
      let keys = Object.keys(registroCopia);
      let temp = [];
      for (let i of keys) {
        temp.push(registroCopia[i]);
      }
      
      let cargo = temp[14]
      let nome = temp[2];
      let cpf = temp[3];
      let curriculo = temp[4];
      let email = temp[0];
      let situacao = temp[15];

      let linha = {
        cargo: cargo,
        nome: nome,
        cpf: cpf,
        curriculo: curriculo,
        email: email,
        situacao: situacao,
      };

      planilha.getWorksheet("Geral").addRow(linha).font = { name: 'Rubik', family: 2, size: 11 };
    }
    planilha.getWorksheet("Geral").getCell('A1').font = {name: 'Rubik',color: { argb: 'FFFFFF' },family: 2,size: 11,},
    planilha.getWorksheet("Geral").getCell('A1').alignment= {vertical: 'middle', horizontal: 'center' },
    planilha.getWorksheet("Geral").getCell('A1').fill= {type: 'pattern', pattern: 'solid', fgColor: {argb: 'FFA4616'}}
    planilha.getWorksheet("Geral").getCell('B1').font = {name: 'Rubik',color: { argb: 'FFFFFF' },family: 2,size: 11,},
    planilha.getWorksheet("Geral").getCell('B1').alignment= {vertical: 'middle', horizontal: 'center' },
    planilha.getWorksheet("Geral").getCell('B1').fill= {type: 'pattern', pattern: 'solid', fgColor: {argb: 'FFA4616'}}
    planilha.getWorksheet("Geral").getCell('C1').font = {name: 'Rubik',color: { argb: 'FFFFFF' },family: 2,size: 11,},
    planilha.getWorksheet("Geral").getCell('C1').alignment= {vertical: 'middle', horizontal: 'center' },
    planilha.getWorksheet("Geral").getCell('C1').fill= {type: 'pattern', pattern: 'solid',fgColor: {argb: 'FFA4616'}}
    planilha.getWorksheet("Geral").getCell('D1').font = {name: 'Rubik',color: { argb: 'FFFFFF' },family: 2,size: 11,},
    planilha.getWorksheet("Geral").getCell('D1').alignment= {vertical: 'middle', horizontal: 'center' },
    planilha.getWorksheet("Geral").getCell('D1').fill= {type: 'pattern', pattern: 'solid',fgColor: {argb: 'FFA4616'}}
    planilha.getWorksheet("Geral").getCell('E1').font = {name: 'Rubik',color: { argb: 'FFFFFF' },family: 2,size: 11,},
    planilha.getWorksheet("Geral").getCell('E1').alignment= {vertical: 'middle', horizontal: 'center' },
    planilha.getWorksheet("Geral").getCell('E1').fill= {type: 'pattern', pattern: 'solid',fgColor: {argb: 'FFA4616'}}
    planilha.getWorksheet("Geral").getCell('F1').font = {name: 'Rubik',color: { argb: 'FFFFFF' },family: 2,size: 11,},
    planilha.getWorksheet("Geral").getCell('F1').alignment= {vertical: 'middle', horizontal: 'center' },
    planilha.getWorksheet("Geral").getCell('F1').fill= {type: 'pattern', pattern: 'solid',fgColor: {argb: 'FFA4616'}}


    planilha.xlsx.writeBuffer().then((data) => {
      let blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      
      saveAs(blob, "Relatório de Candidaturas"+'.xlsx');
    });
  }

  exportRelatorioCandidaturaAnalitico(registros:any){
    let planilha = new Workbook();

    let paginas : any[] = [];
    paginas.push(planilha.addWorksheet("Geral")
    .columns =[
      { header: "Cargo", key: "cargo", width: 15,style: {alignment: {vertical: 'middle', horizontal: 'center' }}},
      { header: "Nome", key: "nome", width: 35,style: {alignment: {vertical: 'middle', horizontal: 'center' }}},
      { header: "CPF", key: "cpf", width: 25,style: {alignment: {vertical: 'middle', horizontal: 'center' }}},
      { header: "Currículo", key: "curriculo", width: 25,style: {alignment: {vertical: 'middle', horizontal: 'center' }}},
      { header: "E-mail", key: "email", width: 25,style: {alignment: {vertical: 'middle', horizontal: 'center' }}},
      { header: "Situação", key: "situacao", width: 25,style: {alignment: {vertical: 'middle', horizontal: 'center' }}},
      { header: "Aprovador", key: "aprovador", width: 25,style: {alignment: {vertical: 'middle', horizontal: 'center' }}},
      { header: "Análise", key: "analise", width: 25,style: {alignment: {vertical: 'middle', horizontal: 'center' }}},
      { header: "Observação", key: "observacao", width: 25,style: {alignment: {vertical: 'middle', horizontal: 'center' }}},
      { header: "Justificativa", key: "justificativaIndeferimento", width: 25,style: {alignment: {vertical: 'middle', horizontal: 'center' }}},
    ]);
    
    for (let registro of registros) {
      let registroCopia = JSON.parse(JSON.stringify(registro));
      delete registroCopia.id;
      let keys = Object.keys(registroCopia);
      let temp = [];
      for (let i of keys) {
        temp.push(registroCopia[i]);
      }
      
      let cargo = temp[0]
      let nome = temp[1];
      let cpf = temp[2];
      let curriculo = temp[3];
      let email = temp[4];
      let situacao = temp[5];
      let aprovador = temp[6];
      let analise = temp[7];
      let observacao = temp[8];
      let justificativaIndeferimento = temp[9];

      let linha = {
        cargo: cargo,
        nome: nome,
        cpf: cpf,
        curriculo: curriculo,
        email: email,
        situacao: situacao,
        aprovador: aprovador,
        analise: analise,
        observacao: observacao,
        justificativaIndeferimento: justificativaIndeferimento,
      };

      planilha.getWorksheet("Geral").addRow(linha).font = { name: 'Rubik', family: 2, size: 11 };
    }
    planilha.getWorksheet("Geral").getCell('A1').font = {name: 'Rubik',color: { argb: 'FFFFFF' },family: 2,size: 11,},
    planilha.getWorksheet("Geral").getCell('A1').alignment= {vertical: 'middle', horizontal: 'center' },
    planilha.getWorksheet("Geral").getCell('A1').fill= {type: 'pattern', pattern: 'solid', fgColor: {argb: 'FFA4616'}}
    planilha.getWorksheet("Geral").getCell('B1').font = {name: 'Rubik',color: { argb: 'FFFFFF' },family: 2,size: 11,},
    planilha.getWorksheet("Geral").getCell('B1').alignment= {vertical: 'middle', horizontal: 'center' },
    planilha.getWorksheet("Geral").getCell('B1').fill= {type: 'pattern', pattern: 'solid', fgColor: {argb: 'FFA4616'}}
    planilha.getWorksheet("Geral").getCell('C1').font = {name: 'Rubik',color: { argb: 'FFFFFF' },family: 2,size: 11,},
    planilha.getWorksheet("Geral").getCell('C1').alignment= {vertical: 'middle', horizontal: 'center' },
    planilha.getWorksheet("Geral").getCell('C1').fill= {type: 'pattern', pattern: 'solid',fgColor: {argb: 'FFA4616'}}
    planilha.getWorksheet("Geral").getCell('D1').font = {name: 'Rubik',color: { argb: 'FFFFFF' },family: 2,size: 11,},
    planilha.getWorksheet("Geral").getCell('D1').alignment= {vertical: 'middle', horizontal: 'center' },
    planilha.getWorksheet("Geral").getCell('D1').fill= {type: 'pattern', pattern: 'solid',fgColor: {argb: 'FFA4616'}}
    planilha.getWorksheet("Geral").getCell('E1').font = {name: 'Rubik',color: { argb: 'FFFFFF' },family: 2,size: 11,},
    planilha.getWorksheet("Geral").getCell('E1').alignment= {vertical: 'middle', horizontal: 'center' },
    planilha.getWorksheet("Geral").getCell('E1').fill= {type: 'pattern', pattern: 'solid',fgColor: {argb: 'FFA4616'}}
    planilha.getWorksheet("Geral").getCell('F1').font = {name: 'Rubik',color: { argb: 'FFFFFF' },family: 2,size: 11,},
    planilha.getWorksheet("Geral").getCell('F1').alignment= {vertical: 'middle', horizontal: 'center' },
    planilha.getWorksheet("Geral").getCell('F1').fill= {type: 'pattern', pattern: 'solid',fgColor: {argb: 'FFA4616'}},
    planilha.getWorksheet("Geral").getCell('G1').font = {name: 'Rubik',color: { argb: 'FFFFFF' },family: 2,size: 11,},
    planilha.getWorksheet("Geral").getCell('G1').alignment= {vertical: 'middle', horizontal: 'center' },
    planilha.getWorksheet("Geral").getCell('G1').fill= {type: 'pattern', pattern: 'solid',fgColor: {argb: 'FFA4616'}}
    planilha.getWorksheet("Geral").getCell('H1').font = {name: 'Rubik',color: { argb: 'FFFFFF' },family: 2,size: 11,},
    planilha.getWorksheet("Geral").getCell('H1').alignment= {vertical: 'middle', horizontal: 'center' },
    planilha.getWorksheet("Geral").getCell('H1').fill= {type: 'pattern', pattern: 'solid',fgColor: {argb: 'FFA4616'}}
    planilha.getWorksheet("Geral").getCell('I1').font = {name: 'Rubik',color: { argb: 'FFFFFF' },family: 2,size: 11,},
    planilha.getWorksheet("Geral").getCell('I1').alignment= {vertical: 'middle', horizontal: 'center' },
    planilha.getWorksheet("Geral").getCell('I1').fill= {type: 'pattern', pattern: 'solid',fgColor: {argb: 'FFA4616'}}
    planilha.getWorksheet("Geral").getCell('J1').font = {name: 'Rubik',color: { argb: 'FFFFFF' },family: 2,size: 11,},
    planilha.getWorksheet("Geral").getCell('J1').alignment= {vertical: 'middle', horizontal: 'center' },
    planilha.getWorksheet("Geral").getCell('J1').fill= {type: 'pattern', pattern: 'solid',fgColor: {argb: 'FFA4616'}}


    planilha.xlsx.writeBuffer().then((data) => {
      let blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      
      saveAs(blob, "Relatório de Candidaturas Analítico"+'.xlsx');
    });
  }

}
